import { api } from '@/lib/api';
import type { IApiResponse, IProduct } from '@skystone/shared';

export const productApi = {
  getAll: async (options?: { includeArchived?: boolean }): Promise<IProduct[]> => {
    const params = new URLSearchParams();
    if (options?.includeArchived) params.set('includeArchived', 'true');
    const query = params.toString();
    const url = query ? `/products?${query}` : '/products';
    const result = await api.get<IApiResponse<IProduct[]>>(url);
    return result.data;
  },

  getById: async (id: string): Promise<IProduct> => {
    const result = await api.get<IApiResponse<IProduct>>(`/products/${id}`);
    return result.data;
  },
};
